(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["price"] && !Shopify.designMode) return;
  try {
    (() => {
    // Show sizes while a finger touches a card (including mid-scroll), back to price on release
    let activeCard = null;

    const clear = () => {
      activeCard?.classList.remove('is-touched');
      activeCard = null;
    };

    document.addEventListener(
      'touchstart',
      (event) => {
        clear();
        const card = event.target instanceof Element ? event.target.closest('product-card') : null;
        if (!card?.querySelector('.price-swap')) return;

        activeCard = card;
        card.classList.add('is-touched');
      },
      { passive: true }
    );

    document.addEventListener('touchend', clear, { passive: true });
    document.addEventListener('touchcancel', clear, { passive: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
